import React from 'react'
import { shallow } from 'enzyme'
import { NewPodCard } from '../NewPodCard'
import NewAdminsList from '../NewAdminsList'

describe('<NewPodCard />', () => {
  let wrapper, instance, props
  beforeEach(() => {
    props = {
      pod: {
        admins: [
          { name: 'test admin 1', rid: 1 },
          { name: 'test admin 2', rid: 2 },
          { name: 'test admin 3', rid: 3 }
        ]
      },
      allAdmins: [],
      managePod() {},
      onCancel() {}
    }
    wrapper = shallow(<NewPodCard {...props} />)
    instance = wrapper.instance()
  })
  describe('#isValid', () => {
    describe('when there is no name entered', () => {
      beforeEach(() => {
        wrapper.setState({ name: '' })
      })
      it('should return false', () => {
        expect(instance.isValid()).toBe(false)
      })
    })
    describe('when there are no relationship managers in its `admins` state field', () => {
      beforeEach(() => {
        const noRelationshipManagers = [
          { name: 'not a relationship manager', isRelationshipManager: false, isAccountManager: true }
        ]
        wrapper.setState({ admins: noRelationshipManagers, name: 'hello' })
      })
      it('should return false', () => {
        expect(instance.isValid()).toBe(false)
      })
    })
    describe('when there are no account managers in the `admins` state field', () => {
      beforeEach(() => {
        const noAccountManagers = [
          { name: 'not an account manager', isAccountManager: false, isRelationshipManager: true }
        ]
        wrapper.setState({ admins: noAccountManagers, name: 'test naame' })
      })
      it('should return false', () => {
        expect(instance.isValid()).toBe(false)
      })
    })
    describe('when a name is entered and there are relationship managers and account managers present in the `admins` state field', () => {
      beforeEach(() => {
        const admins = [
          { name: 'hello', isRelationshipManager: true },
          { name: 'nope', isAccountManager: true }
        ]
        wrapper.setState({ admins, name: 'test pod name' })
      })
      it('should return true', () => {
        expect(instance.isValid()).toBe(true)
      })
    })
  })
  describe('#onAdminSelect', () => {
    describe('when the oldAdmin argument is present/has a rid', () => {
      beforeEach(() => {
        const admins = [
          { name: 'hi im an admin', rid: 1 },
          { name: 'hello', rid: 2 }
        ]
        wrapper.setState({ admins })
      })
      it('should replace the old admin with the provided new admin at the same index', () => {
        const oldAdmin = wrapper.state('admins')[0]
        const newAdmin = { name: 'new admin', rid: 4 }
        instance.onAdminSelect({ oldAdmin, newAdmin })
        expect(wrapper.state('admins')[0]).toBe(newAdmin)
      })
    })
    describe('when the oldAdmin argument is not present/does not have a rid', () => {
      it('should add the newAdmin argument to the end of the `admins` state field', () => {
        const newAdmin = { name: 'new admin', rid: 3000 }
        instance.onAdminSelect({ newAdmin })
        const newAdminsState = wrapper.state('admins')
        expect(newAdminsState[newAdminsState.length - 1]).toBe(newAdmin)
      })
    })
  })
  describe('#onAdminRemove', () => {
    beforeEach(() => {
      const admins = [
        { name: 'test admin', rid: 4 },
        { name: 'test admin 2', rid: 9 }
      ]
      wrapper.setState({ admins })
    })
    it('should remove the admin with the provided rid', () => {
      const ridToRemove = 4
      instance.onAdminRemove(ridToRemove)
      expect(wrapper.state('admins').filter(admin => admin.rid === ridToRemove)).toHaveLength(0)
    })
  })
  describe('#onNameChange', () => {
    it('should update the `name` state field with the event target value', () => {
      const e = { target: { value: 'test val' } }
      instance.onNameChange(e)
      expect(wrapper.state('name')).toBe(e.target.value)
    })
  })
  describe('#onSubmit', () => {
    it('should set the component loading state to true', () => {
      wrapper.setState({ loading: false })
      instance.onSubmit()
      expect(wrapper.state('loading')).toBe(true)
    })
    it('should call the managePod prop', () => {
      const managePodMock = jest.fn()
      wrapper.setProps({ managePod: managePodMock })
      wrapper.update()
      instance.onSubmit()
      expect(managePodMock).toHaveBeenCalledTimes(1)
    })
    it('should call the onCancel prop', async () => {
      const onCancelMock = jest.fn()
      wrapper.setProps({ onCancel: onCancelMock })
      wrapper.update()
      instance.forceUpdate()
      await instance.onSubmit()
      expect(onCancelMock).toHaveBeenCalledTimes(1)
    })
  })
  describe('#render', () => {
    it('should return something', () => {
      expect(instance.render()).toBeTruthy()
    })
  })
})
